/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ControlActions from './ControlActions';
import { setSelectedControlObject } from '../actions/report-designer.actions';
import {
  CONTROL_TYPES_WITH_MARGIN_BOTTOM,
  CONTROL_TYPES_WITH_SIMPLE_BLOCK_STYLES,
  CONTROL_TYPES_WITHOUT_ACTIONS,
  REPORT_CONTROL_TYPE,
} from '../constants/report-designer.constants';
import {
  getHasControlWrapper,
  getHasValidationErrorById,
  getIsControlPropertiesChanged,
  getIsControlSelected,
  getIsNewAddedControl,
} from '../selectors/report-designer.selectors';

const useStyles = makeStyles({
  main: {
    cursor: 'pointer',
    borderRadius: 5,
    border: 'solid 1px transparent',
    borderStyle: 'dashed',
    padding: '6px 4px',
    position: 'relative',
    '&:hover *': {
      cursor: 'pointer',
    },
  },
  marginBottom: {
    '&:not(:last-child)': {
      marginBottom: 8,
    },
  },
  hover: {
    border: 'dashed 1px #ccc',
  },
  selectedWithWrapper: {
    borderColor: '#6c6969',
    background: '#f6f7fb',
    '&:hover': {
      borderColor: '#6c6969',
    },
    '& div[class*="MuiPaper-root"]': {
      backgroundColor: '#f6f7fb',
    },
  },
  hasUIChanges: {
    borderColor: 'orange !important',
    '&:hover': {
      borderColor: 'orange !important',
    },
  },
  simpleBlock: {
    marginBottom: 8,
    marginRight: 8,
    minWidth: 200,
    maxWidth: 350,
  },
  blueBackground: {
    backgroundColor: '#8dc6ff',
  },
  error: {
    border: 'solid 2px red !important',
    '&:hover': {
      border: 'solid 2px red !important',
    },
  },
  reportText: {
    marginBottom: 8,
  },
});

const ControlWrapper = ({ children, id, controlType }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const isSelected = useSelector((state) => getIsControlSelected(state, { id }));
  const hasControlWrapper = useSelector((state) => getHasControlWrapper(state, { id }));
  const isControlPropertiesChanged = useSelector((state) =>
    getIsControlPropertiesChanged(state, { id })
  );
  const isNewAddedControl = useSelector((state) => getIsNewAddedControl(state, { id }));
  const hasValidationError = useSelector((state) => getHasValidationErrorById(state, { id }));

  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();

    if (hasControlWrapper && isSelected) {
      dispatch(setSelectedControlObject(id, false));
    } else {
      dispatch(setSelectedControlObject(id, true));
    }
  };

  return (
    <div
      className={classNames({
        [classes.main]: true,
        [classes.marginBottom]: CONTROL_TYPES_WITH_MARGIN_BOTTOM.includes(controlType),
        [classes.hover]: isHovered,
        [classes.reportText]: [
          REPORT_CONTROL_TYPE.PAGE_HEADER,
          REPORT_CONTROL_TYPE.PAGE_FOOTER,
        ].includes(controlType),
        [classes.selectedWithWrapper]: hasControlWrapper && isSelected,
        [classes.hasUIChanges]: isNewAddedControl || isControlPropertiesChanged,
        [classes.simpleBlock]: CONTROL_TYPES_WITH_SIMPLE_BLOCK_STYLES.includes(controlType),
        [classes.blueBackground]:
          CONTROL_TYPES_WITH_SIMPLE_BLOCK_STYLES.includes(controlType) ||
          controlType === REPORT_CONTROL_TYPE.CROSS_TAB_ROW,
        [classes.error]: hasValidationError,
      })}
      onClick={handleClick}
      onMouseEnter={(e) => {
        e.stopPropagation();
        setIsHovered(true);
      }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        setIsHovered(false);
      }}
    >
      {CONTROL_TYPES_WITHOUT_ACTIONS.includes(controlType) ? (
        children
      ) : (
        <ControlActions
          id={id}
          controlType={controlType}
          isActionsVisible={isSelected && hasControlWrapper}
        >
          {children}
        </ControlActions>
      )}
    </div>
  );
};

export default ControlWrapper;
